import { HTTP } from "@/http-common";

import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

const state = {
  clawbacks: [],
  runs: 0,
};

const actions = {
  getClawBacks({ dispatch, commit }, runId) {
    return new Promise((resolve, reject) => {
      dispatch("message/reset", null, {
        root: true,
      });

      var response = HTTP.get(`Commissions/GetClawbacks/${runId}`);
      response
        .then(function(data) {
          var resultData = data.data;
          commit("setClawBacks", resultData);
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissionss : " + err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  commitClawBacks({ dispatch, commit, rootState }, clawbacks) {
    return new Promise((resolve, reject) => {
      dispatch("message/reset", null, {
        root: true,
      });
      if (clawbacks) {
        var response = HTTP.post(
          `Commissions/SetClawBacks/${rootState.commissions.run.runId}`,
          clawbacks
        );
        response
          .then(function(data) {
            var resultData = data.data;
            commit("setClawBacks", resultData);
            resolve(resultData);
          })
          .catch((err) => {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Error in getting Commissionss : " + err.message,
                httpStatus: 500,
              }),
              {
                root: true,
              }
            );
            reject();
          });
      }
    });
  },
};

const mutations = {
  setClawBacks(state, clawbacks) {
    state.Clawbacks = clawbacks;
  },
  setRuns(state, runs) {
    Object.assign(state.runs, runs);
  },
  updateField,
};

const getters = {
  getField,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
